import loadScript from "../utilities/loadScript";
import { waitForThirdParty } from "@magnit/core/src/utilities/async";

const SLOT_API_URL = "https://yandex.ru/ads/system/context.js";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: типизировать "сырой" конфиг яндекс рекламы
type AdConfig = any;

type WithYa = {
  yaContextCb?: unknown[];
  Ya?: {
    adfoxCode?: {
      createAdaptive(
        adConfig: AdConfig,
        devices: ("desktop" | "tablet" | "phone")[],
        breakpoints: {
          tabletWidth: number;
          phoneWidth: number;
        },
      ): void;
    };
  };
};

export default function () {
  const isYaContextAvailable = (): boolean => {
    if (typeof window === "undefined") {
      return false;
    }
    const windowWithYa = window as unknown as WithYa;
    return Boolean(windowWithYa.yaContextCb && windowWithYa.Ya);
  };

  const loadSlotApi = async (): Promise<boolean> => {
    if (isYaContextAvailable()) {
      return true;
    }

    try {
      await loadScript(SLOT_API_URL);
      await waitForThirdParty("yaContextCb").catch((error) =>
        console.error(error),
      );
      // тут была такая фолбек заглушка, видимо нужна чтобы пользовательский код в каком-нибудь GTM не ломался
      // поэтому оставляем её если вдруг ну совсем не загрузились
      (window as unknown as WithYa).yaContextCb =
        (window as unknown as WithYa).yaContextCb || [];
      return true;
    } catch {
      return false;
    }
  };

  const pushAd = (
    adConfig: AdConfig,
    devices: ("desktop" | "tablet" | "phone")[],
    breakpoints: {
      tabletWidth: number;
      phoneWidth: number;
    },
  ) => {
    if (!isYaContextAvailable()) {
      return;
    }

    const windowWithYa = window as unknown as WithYa;
    windowWithYa.yaContextCb?.push(() => {
      windowWithYa.Ya?.adfoxCode?.createAdaptive(
        adConfig,
        devices,
        breakpoints,
      );
    });
  };

  return {
    loadSlotApi,
    isYaContextAvailable,
    pushAd,
  };
}
